(function() {
  const STATS_API_URL = 'https://shopify-stats-api-aos0.onrender.com/api/statistics';
  const PING_API_URL = 'https://shopify-stats-api-aos0.onrender.com/api/ping';
  const UPDATE_DISPLAY_INTERVAL = 10000;
  const PING_INTERVAL = 30000;
  const DEBUG_MODE = false;
  function generateToken() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }
  function getVisitorToken() {
    try {
      let token = localStorage.getItem('visitorToken');
      if (!token) {
        token = generateToken();
        localStorage.setItem('visitorToken', token);
      }
      return token;
    } catch (e) {
      if (DEBUG_MODE) console.warn('localStorage ei saatavilla:', e);
      return generateToken();
    }
  }
  const visitorToken = getVisitorToken();
  let fetchIntervalId = null;
  let pingIntervalId = null;
  let latestLiveVisitors = null;
  // --- KAUPUNKIEN NÄYTTÖ (uusi) ---
  function capitalize(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  function showCities(data) {
    if (data && data.live_visitors_by_city) {
      const list = Object.entries(data.live_visitors_by_city)
        .filter(([city]) => city && city !== 'UNKNOWN')
        .map(([city, count]) => `${capitalize(city)}: ${count}`)
        .join(', ');
      document.getElementById('live-visitors-cities').textContent =
        list ? `Live visitors by city: ${list}` : 'Live visitors by city: No data';
    } else {
      document.getElementById('live-visitors-cities').textContent = '';
    }
  }
  function fetchLiveVisitors() {
    fetch(STATS_API_URL, {
      headers: {
        'X-Visitor-Token': visitorToken
      }
    })
      .then(response => {
        if (!response.ok) {
          if (DEBUG_MODE) console.error('Tilastojen haku epäonnistui:', response.status);
          return null;
        }
        return response.json();
      })
      .then(data => {
        if (data && typeof data.live_visitors !== 'undefined') {
          latestLiveVisitors = data.live_visitors;
        }
        showCities(data); // <-- KAUPUNKIEN NÄYTTÖ
      })
      .catch(err => {
        if (DEBUG_MODE) console.error('Virhe tilastojen haussa:', err);
      });
  }
  function pingServer() {
    fetch(PING_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Visitor-Token': visitorToken
      }
    })
    .then(response => {
      if (!response.ok) {
        if (DEBUG_MODE) {
          console.error('Ping failed with HTTP status:', response.status, response.statusText);
        }
      }
    })
    .catch(err => {
      if (DEBUG_MODE) {
        console.error('Ping network error:', err);
      }
    });
  }
  function startIntervals() {
    fetchLiveVisitors();
    pingServer();
    fetchIntervalId = setInterval(fetchLiveVisitors, UPDATE_DISPLAY_INTERVAL);
    pingIntervalId = setInterval(pingServer, PING_INTERVAL);
    if (DEBUG_MODE) console.log('Intervallit käynnistetty');
  }
  function stopIntervals() {
    if (fetchIntervalId) clearInterval(fetchIntervalId);
    if (pingIntervalId) clearInterval(pingIntervalId);
    fetchIntervalId = null;
    pingIntervalId = null;
    if (DEBUG_MODE) console.log('Intervallit pysäytetty');
  }
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      stopIntervals();
    } else {
      startIntervals();
    }
  });
  window.addEventListener('beforeunload', function() {
    stopIntervals();
  });
  if (!document.hidden) {
    startIntervals();
  }
})();